import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { Page, Content } from '@backstage/core-components';
import { Breadcrumbs } from '@internal/backstage-plugin-global-header';
import { LayoutProps } from '../../types';
import { DesktopLayout } from './DesktopLayout';

const useStyles = makeStyles(() => ({
  pageRoot: {
    height: '100% !important',
    maxHeight: '100% !important',
    overflow: 'hidden !important',
    '& > article': {
      display: 'flex',
      flexDirection: 'column',
      height: '100% !important',
      maxHeight: '100% !important',
      overflow: 'hidden !important',
      minHeight: '0 !important',
    },
    '& > article > *:first-child': {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: '0 !important',
      overflow: 'hidden !important',
      height: '100% !important',
      maxHeight: '100% !important',
    },
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxHeight: '100%',
    overflow: 'hidden',
    boxSizing: 'border-box',
  },
  layoutContainer: {
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    height: 0,
  },
  // Global override scoped to STS agent chat only
  '@global': {
    'body': {
      overflow: 'hidden',
    },
  },
}));

export const STSAgentChatLayout: React.FC<LayoutProps> = (props) => {
  const classes = useStyles();

  return (
    <Page themeId="tool" className={classes.pageRoot}>
      <Content noPadding>
        <Box className={classes.contentWrapper}>
          <Box style={{ paddingLeft: 24, paddingRight: 24, flexShrink: 0 }}>
            <Breadcrumbs disableMargin />
          </Box>
          <Box className={classes.layoutContainer}>
            <DesktopLayout {...props} />
          </Box>
        </Box>
      </Content>
    </Page>
  );
};